// src/App.js
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./components/shared/ScrollToTop";
import { AuthProvider } from "./providers/AuthProvider";
import AppRoutes from "./routes/Routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./assets/styles/rainbowGlow.css";

function App() {
  return (
    <div className="main_body">
      <Router>
        <AuthProvider>
          <ScrollToTop />
          <AppRoutes />
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
